import React from 'react';
import AppointmentReportsList from './apptreportslist';
import UploadPrescription from './uploadprescription';

const AppointmentPrescriptions = () => {
    return (
        <div className='appointment-reports-container'>
            <div className="upload-actions">
                <UploadPrescription />
            </div>
            <div className="uploaded-docs">
                <AppointmentReportsList isReport={false} />
            </div>
        </div>
    );
};

export default AppointmentPrescriptions;
